<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="title" class="modal-title">{{ title }}</h5>
          <h5 v-if="titleHtml" class="modal-title" v-html="titleHtml"></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h3 v-if="subtitle">{{ subtitle }}</h3>
          <div v-if="description" v-html="description">
          </div>

          <slot>
            Dialog content...
          </slot>
        </div>
        <div class="modal-footer bg-success text-center" @click="closeDialog">
          <div class="w-100 text-white">
            <i class="fas fa-check"></i> OK
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    props: {
      title: {
        type: String
      },
      titleHtml: {
        type: String
      },
      subtitle: {
        type: String
      },
      description: {
        type: String
      },
    },

    methods: {
      closeDialog() {
        $(this.$el).modal('hide')
      }
    },

    mounted() {
      $(this.$el)
        .on('hidden.bs.modal', () => {
          this.$router.back()
        })
        .modal('show')
    }
  }
</script>

<style scoped>
  .modal-footer {
    cursor: pointer;
  }
  .modal-footer:hover {
    opacity: 0.9;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/BaseDialog.vue